import React from 'react';
import { Box, Typography } from '@material-ui/core';

export interface Props {
  title: string;
  subtitle: string;
  align: 'left' | 'center' | 'right';
}

const Title: React.FC<Props> = ({ title, subtitle, align }) => {
  return (
    <Box display="flex" flexDirection="column" alignItems={align}>
      <Typography variant="h4">{title}</Typography>
      <Typography>{subtitle}</Typography>
    </Box>
  );
};

export default Title;
